/*
$(function(){

	var modal_close_button_selector = '.cms-modal-close-button-wrapper',
		modal_backdrop_selector = '.cms-modal-backdrop';

	$(modal_close_button_selector).on('click', function () {

		$(this).fadeOut();
		$(modal_backdrop_selector).fadeOut(function(){

		});

	});

});
*/

var modal_backdrop_selector = '.cms-modal-backdrop',
	modal_close_button_selector = '.cms-modal-close-button-wrapper';

window.openModal = function ($elem) {

	$(modal_backdrop_selector).fadeIn('fast');
	$(modal_close_button_selector).fadeIn('fast');
	$elem.css('zIndex', 2147483647-1).fadeIn('fast');

}

window.closeModal = function ($elem) {

	$(modal_backdrop_selector).fadeOut('fast');
	$(modal_close_button_selector).fadeOut('fast');
	$elem.css('zIndex', 2147483647-1).fadeOut('fast');

}